import { useMemo } from 'react';
import { useUserStore } from '../stores/userStore';

export const useUser = () => {
  const user = useUserStore((state) => state.user);
  const loading = useUserStore((state) => state.loading);

  // Return null while loading for backward compatibility
  if (loading) return null;
  return user;
};

export const useUserStoreActions = () => {
  const fetchUser = useUserStore((state) => state.fetchUser);
  const setUser = useUserStore((state) => state.setUser);
  const clearUser = useUserStore((state) => state.clearUser);

  // Cache the object to prevent infinite loops
  return useMemo(
    () => ({ fetchUser, setUser, clearUser }),
    [fetchUser, setUser, clearUser]
  );
};
